// Utils
import useActiveTreeStructure from '@/utils/hooks/tree-structure/useActiveTreeStructure';

// Lib
import { useProfileHasAccessPage } from '@/utils/hooks/acl/useProfileHasAccessPage';

// Components
import { GroupEmptyState } from '@/components/layouts/LayoutPlatform/components/PageContentWrapper/GroupEmptyState';
import { SocialProfileEmptyState } from '@/components/layouts/LayoutPlatform/components/PageContentWrapper/SocialProfileEmptyState';
import { MultiProfilesEmptyState } from '@/components/layouts/LayoutPlatform/components/PageContentWrapper/MultiProfilesEmptyState';

type PageContentWrapperProps = {
    children: React.ReactNode;
};

export function PageContentWrapper({ children }: PageContentWrapperProps) {
    const { isTreeStructureActivated } = useActiveTreeStructure();

    const {
        activeSocialProfileNoAccess,
        activeGroupNoAccess,
        activeMultiSelectionProfilesNoAccess
    } = useProfileHasAccessPage();

    if (!isTreeStructureActivated) {
        return children;
    }

    if (activeSocialProfileNoAccess) {
        return <SocialProfileEmptyState />;
    }

    if (activeGroupNoAccess) {
        return <GroupEmptyState />;
    }

    if (activeMultiSelectionProfilesNoAccess) {
        return <MultiProfilesEmptyState />;
    }

    return children;
}
